import React from "react";
import login_bg from "../../../assets/images/log_in_bg_02.png";
import LanguageSwitcher from "components/elements/LanguageSwitcher/LanguageSwitcher";
import styles from "./AuthBackground.module.css";

const AuthBackground = ({ children, showLanguageSwitcher = false }) => {
  return (
    <div className={styles.container} style={{
      backgroundImage: `url(${login_bg})`,
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
      justifyContent: "center",
      alignItems: "center"
    }}>
      {showLanguageSwitcher ? <LanguageSwitcher absolute /> : <React.Fragment />}
      <div className={styles.body}>{children}</div>
    </div>
  );
};

export default AuthBackground;
